import { render } from "./DirreccionView.vue?vue&type=template&id=3add93eb&ts=true"
import script from "./DirreccionView.vue?vue&type=script&lang=ts"
export * from "./DirreccionView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\RESPALDO 17-01-26 PC\\git\\adminSanatorio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__